function httpAbortFactory(regexp) {
  function httpAbort({ http, resolve }) {
    http.abort(resolve.value(regexp))
  }

  return httpAbort
}

export default httpAbortFactory
